import clsx from 'clsx';
import { FunctionComponent, PropsWithChildren, useEffect } from 'react';
import styles from './OverDetail.module.scss';

interface OverDetailProps extends PropsWithChildren {
    className?: string;
    withoutScroll?: boolean;
    fullWindow?: boolean;
    fullHeight?: boolean;
    pageSidebar?: boolean;
}

// MUI-free replacement for src/components/UI/OverDetail.tsx.
// Renders a fixed, full-viewport overlay while hiding the app header and
// locking body scroll for as long as it is mounted.
export const OverDetail: FunctionComponent<OverDetailProps> = ({
    className,
    withoutScroll,
    fullWindow,
    fullHeight,
    pageSidebar,
    children
}) => {
    useEffect(() => {
        const header = document.querySelector<HTMLElement>('.MuiAppBar-root');

        if (header) {
            header.style.cssText = 'position: fixed; top: 0px; left: 0px; right: 0px;';
        }
        document.body.style.overflow = 'hidden';

        return () => {
            if (header) {
                header.style.cssText = '';
            }
            document.body.style.overflow = 'auto';
        };
    }, []);

    const detail = <div className={styles.detailContainer}>{children}</div>;

    return (
        <div
            className={clsx(
                styles.container,
                {
                    [styles.fullWindow]: fullWindow,
                    [styles.fullHeight]: fullHeight,
                    [styles.pageSidebar]: pageSidebar
                },
                className
            )}
        >
            {withoutScroll ? detail : <div className={styles.scroll}>{detail}</div>}
        </div>
    );
};

export default OverDetail;
